import { AbstractControl, ValidationErrors } from '@angular/forms';

export function AddressValidator(control: AbstractControl): ValidationErrors | null {

    if ((control.get('countryCode') && control.get('countryCode').value === 'US') ||
        (control.get('country') && control.get('country').value === 'US')) {
        if (control.get('state') && control.get('state').value && control.get('state').value.length > 2)
            return {
                state: true
            };
    }

    return null;
}
